import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ConfirmationDeleteDialogContent from './ConfirmationDeleteContent';

interface ConfirmationTableDialogProps {
  /** Opzionale per retrocompatibilità. Se passato, il dialog diventa "controllato" */
  open?: boolean;
  /** L'ID della riga da eliminare */
  id: number | null;
  /** Messaggio personalizzato */
  message?: string;
  /** Callback di chiusura esterna o interna */
  onClose?: () => void;
  /** Callback di conferma per la modalità controllata */
  onConfirm?: (id: number) => void;
  tag?: boolean;

  // PROPS VECCHIE (Mantenute per retrocompatibilità con getActions)
  handleOnClose?: () => void;
  handleDelete?: (id: number) => void;
}

export default function ConfirmationDeleteTableDialog({
  open,
  id,
  message,
  onClose,
  onConfirm,
  tag = true,
  handleOnClose,
  handleDelete
}: ConfirmationTableDialogProps) {
  const { t } = useTranslation();

  // Stato interno usato SOLO nella vecchia modalità autonoma
  const [internalOpen, setInternalOpen] = useState(false);

  // Determina se il componente è controllato dall'esterno (nuovo Menu) o autonomo (vecchio getActions)
  const isControlled = open !== undefined;
  const isOpen = isControlled ? open : internalOpen;

  const handleOpenDialog = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setInternalOpen(true);
  };

  const handleCloseDialog = (e?: React.MouseEvent) => {
    if (e) e.stopPropagation();
    if (isControlled) {
      if (onClose) onClose();
    } else {
      setInternalOpen(false);
      if (handleOnClose) handleOnClose();
    }
  };

  const handleConfirmDelete = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (!isOpen) return;

    if (id !== null) {
      if (isControlled && onConfirm) {
        onConfirm(id);
      } else if (!isControlled && handleDelete) {
        handleDelete(id);
      }
    }
    handleCloseDialog();
  };

  return (
    <>
      {/* Rende il pulsante d'azione SOLO se NON è controllato dal Menu Contestuale */}
      {!isControlled && (
        <IconButton
          id="delete-action-button"
          onClick={handleOpenDialog}
          color="error"
          size="small"
          sx={{
            '&:hover': {
              backgroundColor: 'error.lighter'
            }
          }}>
          <DeleteIcon />
          {tag && (
            <Typography variant="body2" sx={{ ml: 1 }}>
              {t('actions.delete', 'Elimina')}
            </Typography>
          )}
        </IconButton>
      )}
      <ConfirmationDeleteDialogContent
        openDialog={isOpen}
        message={message}
        handleCloseDialog={(e: any) => handleCloseDialog(e)}
        handleConfirmDelete={handleConfirmDelete}
        onClick={(e) => e.stopPropagation()}
      />
    </>
  );
}
